module.exports = __webpack_public_path__ + "static/media/x-squad.17deae8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x-squad.svg
// module id = 1641
// module chunks = 0